import { FEATURE_NAME } from 'src/redesign/features/EventsFilters/constants';
import { createSlice } from '@reduxjs/toolkit';
import { EventsFiltersState } from 'src/redesign/features/EventsFilters/types';
import * as actions from './actions';

const initialState: EventsFiltersState = {
  eventAttendeesFilterValues: null,
  filtersData: null,
  parentEventId: '',
  error: null,
  loading: false,
};

const CLEAR_FILTERS_DATA = {
  attendee_order: '',
  selected_attendee_status: '',
  selected_attendee_email: '',
  selected_attendee: '',
  selected_ticket_uuid: '',
  selected_event_ids: '',
  include_all_occurrences: 'false',
  show_waitlist_subscribers: '',
  show_unsent_emails: '',
  is_filtered: false,
  offset: '0',
  limit: '10',
};
export const eventsFiltersSlice = createSlice({
  name: FEATURE_NAME,
  initialState,
  reducers: {
    setFiltersData: (state, action) => {
      state.filtersData = { ...state.filtersData, ...action.payload };
    },
    cleatFiltersData: (state) => {
      state.filtersData = CLEAR_FILTERS_DATA;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(actions.fetchEventAttendeesFilterValues.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;
      state.eventAttendeesFilterValues = action.payload.data;

      // Store parent event ID for later use
      const parentEventId = action.meta.arg.eventId;
      state.parentEventId = parentEventId || '';

      const newData = {
        ...CLEAR_FILTERS_DATA,
        selected_event_ids: parentEventId || '',
        include_all_occurrences: 'true', // Initially show all occurrences
      };
      state.filtersData = newData;
    });
    builder.addCase(actions.fetchEventAttendeesFilterValues.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(actions.fetchEventAttendeesFilterValues.rejected, (state, action) => {
      state.error = action.error.message;
      state.loading = false;
    });

    // Handle loading more occurrences
    builder.addCase(actions.loadMoreOccurrences.fulfilled, (state, action) => {
      state.loading = false;
      state.error = null;

      if (state.eventAttendeesFilterValues) {
        // Append new occurrences to existing ones
        state.eventAttendeesFilterValues.occurrences = [
          ...state.eventAttendeesFilterValues.occurrences,
          ...action.payload.data.occurrences,
        ];

        // Update pagination metadata
        state.eventAttendeesFilterValues.pagination = action.payload.data.pagination;
      }
    });
    builder.addCase(actions.loadMoreOccurrences.pending, (state) => {
      state.loading = true;
      state.error = null;
    });
    builder.addCase(actions.loadMoreOccurrences.rejected, (state, action) => {
      state.error = action.error.message;
      state.loading = false;
    });
  },
});

export const setFiltersDataAction = eventsFiltersSlice.actions.setFiltersData;
export const clearFiltersDataAction = eventsFiltersSlice.actions.cleatFiltersData;
